<template>
  <div class="contact">
    <div class="topImg row">
      <div class="col-md-12">
        <img
          style="object-fit: cover;"
          :src="navCover"
          alt="南京小程序开发"
          title="南京小程序开发"
        />
        <div class="texts">
          <div>联系我们</div>
          <div>
            去繁就简，留给你最好的体验，始终坚持契约精神，给我们一个机会，我们只会让你喜出望外。
          </div>
        </div>
      </div>
    </div>

    <div class="about">
      <div class="container">
        <div class="regard row">
          <div class="col-md-7">
            <div class="secondary">关于我们</div>
            <div class="hr"></div>
            <p>
              墨客云科技（MokYun）是南京薄幕软件科技旗下的一家提供应用开发、运营、推广的一站式服务提供商，平台致力于为企业的微创新从创意萌芽、产品实现、成长发展提供全面的服务和支持。
            </p>
            <div class="secondary">联系我们</div>
            <div class="hr"></div>
            <div class="contactWay">
              <div>
                <span>联系电话:</span>
                <span>180-129-01065</span>
              </div>
              <div>
                <span>固定电话:</span>
                <span>025-5760-3388</span>
              </div>

              <div>
                <span>业务 QQ:</span>
                <span>534783032</span>
              </div>
              <div>
                <span>联系地址:</span>
                <span>南京市江宁区佳强大厦9层</span>
              </div>
            </div>
            <p></p>
          </div>
          <div class="amap-page-container col-md-5">
            <el-amap vid="amap" :zoom="zoom" :center="center" class="amap-demo">
              <el-amap-info-window
                :position="currentWindow.position"
                :content="currentWindow.content"
                :visible="currentWindow.visible"
                :events="currentWindow.events"
              >
              </el-amap-info-window>
              <el-amap-marker
                :position="marker.position"
                :plugin="plugin"
                :events="marker.events"
                :visible="marker.visible"
                :draggable="marker.draggable"
              ></el-amap-marker>
            </el-amap>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VueAMap from 'vue-amap';
Vue.use(VueAMap);
export default {
  data() {
    return {
      navCover: 'https://cdn1-open.mokyun.com/1541475595720',
      zoom: 14,
      center: [118.826513, 31.868044],
      marker: {
        position: [118.826513, 31.868044],
        events: {
          click: () => {
            if (this.windows[0].visible == true) {
              this.windows[0].visible = false;
            } else {
              this.windows[0].visible = true;
            }
          },
          dragend: (e) => {
            this.markers[0].position = [e.lnglat.lng, e.lnglat.lat];
          },
        },
        visible: true,
        draggable: false,
      },
      plugin: {
        pName: 'Scale',
        events: {
          init(instance) {},
        },
      },
      windows: [
        {
          position: [118.8318632443886, 31.8646712110525],
          content:
            '<h4>地址:</h4><div class="text item">南京市江宁区佳强大厦9层</div>',
          visible: true,
          events: {
            close() {},
          },
        },
      ],
      slotWindow: {
        position: [118.8318632443886, 31.8646712110525],
      },
      currentWindow: {
        position: [0, 0],
        content: '',
        events: {},
        visible: false,
      },
    };
  },
  created() {
    VueAMap.initAMapApiLoader({
      key: 'd01f4eccac443b5ea9e7788001b082a2',
      plugin: [
        'AMap.Autocomplete',
        'AMap.PlaceSearch',
        'AMap.Scale',
        'AMap.OverView',
        'AMap.ToolBar',
        'AMap.MapType',
        'AMap.PolyEditor',
        'AMap.CircleEditor',
      ],
      v: '1.4.4',
    });
  },
  mounted() {
    this.currentWindow = this.windows[0];
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  },
  methods: {
    // 地图
    switchWindow(tab) {
      this.currentWindow.visible = false;
      this.$nextTick(() => {
        this.currentWindow = this.windows[tab];
        this.currentWindow.visible = true;
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.contact {
  width: 100%;
  background: #fafafa;
}
.row {
  margin: 0;
  padding: 0;
}
.topImg {
  width: 100%;
}
.topImg .col-md-12 {
  width: 100%;
  padding: 0;
  position: relative;
}
.topImg img {
  width: 100%;
  height: 100%;
}
.topImg .texts {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
}
.topImg .texts > div {
  width: 100%;
  text-align: center;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.topImg .texts > div:nth-child(1) {
  height: 60%;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: 8px;
  font-size: 50px;
  font-family: '黑体';
  font-weight: 600;
}
.topImg .texts > div:nth-child(2) {
  height: 40%;
  font-size: 15px;
  font-family: '黑体';
}
@media only screen and (min-width: 1100px) and (max-width: 1400px) {
  .topImg .texts > div:nth-child(1) {
    font-size: 3rem;
  }
  .topImg .texts > div:nth-child(2) {
    font-size: 13px;
  }
}
@media only screen and (min-width: 760px) and (max-width: 1100px) {
  .topImg .texts > div:nth-child(1) {
    font-size: 2rem;
  }
  .topImg .texts > div:nth-child(2) {
    font-size: 12px;
  }
}
@media only screen and (max-width: 760px) {
  .topImg .texts > div:nth-child(1) {
    font-size: 1.5rem;
  }
  .topImg .texts > div:nth-child(2) {
    font-size: 10px;
    padding: 0 12px;
  }
}
.about {
  width: 100%;
  padding: 4.7em 0;
}

.about .regard {
  width: 100%;
  height: 100%;
  margin: 0 auto;
}
.about .regard .col-md-7 {
  background-color: #ffffff;
  box-shadow: 0px 8px 16px 0px rgba(167, 172, 185, 0.14);
  border: solid 1px #eeeeee;
  margin-right: -2em;
  padding: 0 4em;
}
.about .regard .col-md-7 .hr {
  width: 5.5em;
  height: 1px;
  background-color: #ccc;
  margin-bottom: 2.5em;
  /*margin-left: 2.9em;*/
}
.about .regard .col-md-7 .secondary {
  font-family: 'microsoft yahei';
  margin: 56px 0 13px 0;
  font-size: 28px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 30px;
  letter-spacing: 0px;
  color: #343434;
}
.about .regard .col-md-7 p {
  /*width: 75%;*/
  font-family: 'microsoft yahei';
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 30px;
  letter-spacing: 0px;
  color: #343434;
  margin-bottom: 20px;
  /*margin-left: 59px;*/
}

.contactWay > div {
  /*width: 75%;*/
  /*margin-left: 59px;*/
  text-align: left;
  font-size: 16px;
  font-family: 'microsoft yahei';
  font-weight: normal;
  font-stretch: normal;
  line-height: 40px;
  letter-spacing: 0px;
  color: #343434;
}
.contactWay > div span:nth-child(1) {
  display: inline-block;
}
.about .regard .col-md-5 {
  /* box-shadow: 0px 8px 16px 0px
		rgba(217, 217, 217, 0.14); */
  border: solid 1px #cccccc;
  height: 28.5em;
  border: none;
  margin-top: 4em;
  padding-left: 50px;
}
.about .regard .col-md-5 .amap-demo {
  width: 100%;
  height: 100%;
  border-radius: 5px;
  overflow: hidden;
  box-shadow: 0px 8px 16px 0px rgba(167, 172, 185, 0.14);
}

@media only screen and (max-width: 992px) {
  .about .regard .col-md-5 {
    margin-top: 3em;
    padding: 0;
  }
}

@media only screen and (min-width: 768px) {
  .topImg {
    margin-top: 51px;
  }
}
@media only screen and (max-width: 768px) {
  .about .regard .col-md-5 {
    padding: 0;
  }
  .about .regard .col-md-5 .amap-demo {
    /* width: 95%; */
    margin: 0 auto;
  }
  .about .regard .col-md-7 {
    margin: 0;
  }
  .topImg {
    margin-top: 53px;
  }
}

@media only screen and (max-width: 768px) and (min-width: 680px) {
  .topImg .col-md-12 {
    height: 100px;
  }
}
@media only screen and (max-width: 680px) and (min-width: 460px) {
  .topImg .col-md-12 {
    height: 80px;
  }
}
@media (max-width: 460px) {
  .topImg .col-md-12 {
    height: 170px;
    object-fit: cover;
  }
}

.container {
  width: 80%;
}
@media only screen and (max-width: 1420px) and (min-width: 1160px) {
  .container {
    width: 90%;
  }
  .about .regard .col-md-5 .amap-demo {
    height: 90%;
  }
  .about .regard .col-md-5 {
    margin-top: 2em;
  }
  .about .regard .col-md-7 .hr {
    margin-bottom: 1.5em;
  }
  .about .regard .col-md-7 .secondary {
    font-size: 22px;
    margin: 30px 0 10px;
  }
  .about .regard .col-md-7 p {
    font-size: 14px;
  }
  .contactWay > div {
    font-size: 14px;
    line-height: 30px;
  }
}
@media only screen and (max-width: 1160px) and (min-width: 992px) {
  .container {
    width: 100%;
  }
  .about .regard .col-md-5 .amap-demo {
    height: 90%;
  }
  .about .regard .col-md-5 {
    margin-top: 2em;
  }
  .about .regard .col-md-7 .hr {
    margin-bottom: 1.5em;
  }
  .about .regard .col-md-7 .secondary {
    font-size: 22px;
    margin: 30px 0 10px;
  }
  .about .regard .col-md-7 p {
    font-size: 14px;
  }
  .contactWay > div {
    font-size: 14px;
    line-height: 30px;
  }
}

@media only screen and (max-width: 992px) and (min-width: 770px) {
  .about {
    padding: 3.7em 0;
  }
  .about .regard .col-md-5 .amap-demo {
    width: 104%;
    height: 100%;
  }
  .about .regard .col-md-5 {
    margin-top: 2em;
  }
  .about .regard .col-md-7 .hr {
    margin-bottom: 1.5em;
  }
  .about .regard .col-md-7 .secondary {
    font-size: 22px;
    margin: 30px 0 10px;
  }
  .about .regard .col-md-7 p {
    font-size: 14px;
  }
  .contactWay > div {
    font-size: 14px;
    line-height: 30px;
  }
}

@media only screen and (max-width: 770px) and (min-width: 578px) {
  .about {
    padding: 2.7em 0;
  }
  .about .container {
    width: 90%;
  }
  .about .regard .col-md-5 .amap-demo {
    width: 100%;
    height: 100%;
  }
  .about .regard .col-md-5 {
    margin-top: 2em;
  }
  .about .regard .col-md-7 .hr {
    margin-bottom: 1.2em;
  }
  .about .regard .col-md-7 .secondary {
    font-size: 20px;
    margin: 30px 0 10px;
  }
  .about .regard .col-md-7 p {
    font-size: 14px;
  }
  .contactWay > div {
    font-size: 14px;
    line-height: 30px;
  }
}

@media only screen and (max-width: 578px) {
  .about {
    padding: 0 0 1.7em;
  }
  .about .container {
    width: 100%;
    padding: 0;
  }
  .about .regard .col-md-5 .amap-demo {
    width: 100%;
    height: 100%;
  }
  .about .regard .col-md-5 {
    margin-top: 1em;
  }
  .about .regard .col-md-7 {
    padding: 0 1em;
  }
  .about .regard .col-md-7 .hr {
    margin-bottom: 1em;
  }
  .about .regard .col-md-7 .secondary {
    font-size: 18px;
    margin: 15px 0 5px;
  }
  .about .regard .col-md-7 p {
    font-size: 13px;
  }
  .contactWay > div {
    font-size: 14px;
    line-height: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/contact.vue